import { render, staticRenderFns } from "./BookUploader.vue?vue&type=template&id=124e229e&scoped=true"
import script from "./BookUploader.vue?vue&type=script&lang=ts"
export * from "./BookUploader.vue?vue&type=script&lang=ts"
import style0 from "./BookUploader.vue?vue&type=style&index=0&id=124e229e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e229e",
  null
  
)

export default component.exports